<template>
  <div class="nav">
    <div class="nav-bar">
      <img
        class="nav-bar__logo"
        :src="logo"
      />
      <template v-if="showMenu">
        <span
          class="nav-bar__icon"
          @click="toggleMenu"
          v-html="closeIcon"
        />
      </template>
      <template v-else>
        <span
          class="nav-bar__icon"
          @click="toggleMenu"
          v-html="menuIcon"
        />
      </template>
    </div>
    <transition name="nav">
      <template v-if="showMenu">
        <div class="nav-menu">
          <div class="nav-menu-items">
            <template v-for="item in navigation.items">
              <router-link
                :key="item.title"
                class="nav-menu-item"
                :to="item.routerName"
                :class="{ disabled: !canAccess(item.authorizationResource) }"
              >
                <span
                  class="nav-menu-item__icon"
                  v-html="item.icon"
                />
                <span @click="toggleMenu">{{ item.title }}</span>
              </router-link>
            </template>
          </div>
          <div class="nav-menu-footer">
            <div
              v-tooltip="{ content: 'Logout' }"
              class="nav-menu-item"
              @click="logout"
            >
              <span
                class="nav-menu-item__icon"
                v-html="navigation.icons.logOut"
              />
              Logout
            </div>
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import feather from 'feather-icons'
import logo from '@/assets/logos/link_logo.svg'
import navMixin from '@/mixins/navMixin.js'

export default {
  name: 'MobileMenu',
  mixins: [navMixin],
  data() {
    return {
      logo,
      menuIcon: feather.icons.menu.toSvg(),
      closeIcon: feather.icons.x.toSvg(),
      showMenu: false,
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    canAccess(authorizationResource) {
      // Not every object has a restriction, so if it is null we just assume they have access
      if (authorizationResource) {
        return this.$can('view', authorizationResource)
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.nav {
  z-index: 1;
  &-bar {
    @include flex-display();
    @include flex-align-items(center);
    @include flex-justify-content(space-between);
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0.5em 1em;
    background: $black;
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.3);
    height: $nav-bar-height;
    z-index: 1;
    &__logo {
      width: auto;
      height: 65%;
    }
    &__icon {
      color: $white;
      margin-right: 1em;
    }
  }
  &-menu {
    @include flex-display();
    @include flex-direction(column);
    @include flex-justify-content(space-between);
    z-index: -1;
    position: absolute;
    top: $nav-bar-height;
    left: 0;
    box-sizing: border-box;
    background: linear-gradient($black, $dark-grey);
    padding-top: 1em;
    width: 100%;
    height: calc(100% - #{$nav-bar-height});
    &-item {
      @include flex-display();
      @include flex-align-items(center);
      box-sizing: border-box;
      padding: 1.5em 3em;
      color: $white;
      font-size: $large-font;
      &__icon {
        @include flex-display();
        @include flex-align-items(center);
        margin-right: 1em;
      }
      &.router-link-active {
        color: $green;
      }
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
    &-footer {
      margin-bottom: 1em;
    }
  }
}
@media #{$above-mobile} {
  .nav-bar {
    display: none;
  }
}
</style>
